import {
  mdiBullseyeArrow,
  mdiCarHatchback,
} from '@mdi/js'

import localStorageSlim from 'localstorage-slim'

const userProfile = localStorageSlim.get('userProfile', { decrypt: true })
const profileName = userProfile?.profile?.profile
const profileSector = userProfile?.occupation_sector?.sector?.name?.includes('MARKETING')

const solicitations = [
  {
    subheader: 'Solicitações',
  },
]

if ((userProfile?.occupation_sector?.is_leader || userProfile?.occupation_sector?.is_manager) && profileName === 'Marketing' && profileSector) {
  const marketingExists = solicitations.some(item => item.title === 'Marketing')

  if (!marketingExists) {
    solicitations.push({
      title: 'MARKETING',
      icon: mdiBullseyeArrow,
      children: [
        {
          title: 'Minhas solicitações',
          to: 'solicitations-marketing-home',
          ActiveTabColor: '#05AEFF',
          ActiveTabColor2: '#05AEFF',
          hidden: false,
        },
        {
          title: 'Painel',
          to: 'solicitations-marketing-panel',
          ActiveTabColor: '#05AEFF',
          ActiveTabColor2: '#05AEFF',
          hidden: false,
        },
        {
          title: 'Relatórios',
          to: 'solicitations-marketing-report',
          ActiveTabColor: '#05AEFF',
          ActiveTabColor2: '#05AEFF',
          hidden: false,
        },
        {
          title: 'Ferramentas',
          to: 'solicitations-marketing-tools',
          ActiveTabColor: '#05AEFF',
          ActiveTabColor2: '#05AEFF',
          hidden: false,
        },
      ],
    })
  }
} else if (profileName === 'Marketing' && profileSector) {
  const marketingExists = solicitations.some(item => item.title === 'Marketing')

  if (!marketingExists) {
    solicitations.push({
      title: 'MARKETING',
      icon: mdiBullseyeArrow,
      children: [
        {
          title: 'Minhas solicitações',
          to: 'solicitations-marketing-home',
          ActiveTabColor: '#05AEFF',
          ActiveTabColor2: '#05AEFF',
          hidden: false,
        },
        {
          title: 'Painel',
          to: 'solicitations-marketing-panel',
          ActiveTabColor: '#05AEFF',
          ActiveTabColor2: '#05AEFF',
          hidden: false,
        },
      ],
    })
  }
} else {
  const marketingExists = solicitations.some(item => item.title === 'Marketing')

  if (!marketingExists) {
    solicitations.push({
      title: 'MARKETING',
      icon: mdiBullseyeArrow,
      children: [
        {
          title: 'Minhas solicitações',
          to: 'solicitations-marketing-home',
          ActiveTabColor: '#05AEFF',
          ActiveTabColor2: '#05AEFF',
          hidden: false,
        },
      ],
    })
  }
}

solicitations.push({
  title: 'TRANSPORTE',
  icon: mdiCarHatchback,
  children: [
    {
      title: 'Minhas solicitações',
      to: 'solicitations-transport-home',
      ActiveTabColor: '#05AEFF',
      ActiveTabColor2: '#05AEFF',
      hidden: false,
    },
  ],
})

export default solicitations
